import React, { useState, useEffect } from 'react'
import styles from './style'
import {
  withStyles,
  TextField,
  Divider,
  Typography,
  makeStyles,
} from '@material-ui/core'
import { QuestionFieldNames } from '../../model/card'
import { cardPatchAction, getCardAction } from 'src/reducers/card/action'
import { PatchContent, PatchData } from 'src/model/patch'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useHistory } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { CoreIconButton } from '../core'
import SectionPopover from 'src/components/popover'
import translator from 'src/translate'

import { CardSettingsTypes, TranslateCardTypes } from 'src/model/card'

import {
  componentBoxShowAction,
  componentBoxHideAction,
} from 'src/reducers/component-box/action'
import ComponentBoxContent from 'src/model/component-box'

import { guid } from 'src/utils/guid'
import ModalContent from 'src/components/card-item/card-settings'
import {
  messageBoxShowAction,
  messageBoxHideAction,
} from 'src/reducers/message-box/action'
import MessageBoxContent, { MessageBoxType } from 'src/model/message-box'
import { ButtonData, ButtonType, ButtonActionType } from 'src/model/button'
import { courseRemoveCard } from 'src/reducers/card/action'
import findNextCardAfterDeletion from 'src/hooks/findNextCardAfterDeletion'
import { useCourseSettings } from 'src/hooks/useCourseSettings'
import { useParams } from 'react-router-dom'
const CardTitle = props => {
  const { classes, sections, setSections } = props
  const dispatch = useDispatch()
  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const cardId = searchParams.get('page')
  const course = useSelector(state => state.course.course)
  const entity = useSelector(state => state.card.currentCard)
  const history = useHistory()
  const { subPage } = useParams()

  const [openPopup, setOpenPopup] = React.useState(null)
  const { execute, update, exists, value } = useCourseSettings('theme')

  const font = value ? value.font : null
  const handleClosePopup = () => {
    setOpenPopup(null)
  }
  const [title, setTitle] = useState('')

  useEffect(() => {
    if (entity) {
      setTitle(entity.title || '')
    }
  }, [entity?.id, entity?.title])

  const settingsClickHandler = () => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.WARNING,
          buttons: [],
          title: TranslateCardTypes[entity[QuestionFieldNames.QUESTION_TYPE]]
            ? 'Translate'
            : translator._('action.settings'),
          component: (
            <ModalContent
              cardId={entity.id}
              {...props}
              key={guid.uid}
              closeThisModal={() => {
                dispatch(messageBoxHideAction())
              }}
            />
          ),
          maxWidth: '50vw',
        }),
      ),
    )
  }

  const handleDeletePopup = event => {
    dispatch(
      messageBoxShowAction(
        MessageBoxContent({
          type: MessageBoxType.ERROR,
          buttons: [
            new ButtonData(
              ButtonType.NORMAL,
              'Cancel',
              ButtonActionType.NO,
              e => {
                dispatch(messageBoxHideAction())
              },
            ),
            new ButtonData(
              ButtonType.ACTION,
              'Delete',
              ButtonActionType.DELETE,
              e => {
                const nextCard = findNextCardAfterDeletion(
                  Number(subPage),
                  sections,
                )
                let newSections = sections
                newSections = newSections.map(section => {
                  section.cards = section.cards.filter(
                    sectionCard => sectionCard.id !== Number(subPage),
                  )
                  if (section.cards.length === 0) {
                    return null
                  } else return section
                })

                newSections = newSections.filter(
                  section => section !== null && section.cards.length > 0,
                )
                // Navigate to appropriate page after deletion

                dispatch(
                  courseRemoveCard(course.id, Number(subPage), () => {
                    setSections(newSections)
                  }),
                )
                if (nextCard) {
                  history.push(`/mini-course/${course.id}/page/${nextCard.id}`)
                  dispatch(getCardAction(nextCard.id))
                } else {
                  dispatch(getCardAction(null))
                  history.push(`/mini-course/${course.id}/page/`)
                }

                dispatch(messageBoxHideAction())
              },
            ),
          ],
          title: 'Delete Page',
          note: '',
          description: 'You are about to delete this page.',
        }),
      ),
    )
  }
  const onBlur = async value => {
    if (entity[QuestionFieldNames.TITLE] !== value) {
      dispatch(
        cardPatchAction(
          new PatchData(
            new PatchContent(
              value,
              QuestionFieldNames.TITLE,
              PatchContent.OPERATION_REPLACE,
            ),
            entity[QuestionFieldNames.ID],
          ),
          () => {
            let newSections = sections.map(section => {
              if (section.id === entity.sectionId) {
                return {
                  ...section,
                  cards: section.cards.map(card => {
                    if (card.id === entity.id) {
                      return {
                        ...card,
                        [QuestionFieldNames.TITLE]: value,
                      }
                    }
                    return card
                  }),
                }
              }
              return section
            })

            setSections(newSections)
          },
        ),
      )
    }
  }
  const handleTitleChange = e => {
    setTitle(e.target.value)
  }

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative',
      }}
    >
      <div className={classes.root}>
        <TextField
          placeholder="Untitled Page"
          className={classes.textfield}
          InputProps={{
            className: classes.textfieldInput,
            style: {
              fontFamily: font || 'Inter',
            },
          }}
          inputProps={{
            style: {
              textAlign: 'center',
              padding: 0,
            },
          }}
          onBlur={e => onBlur(e.target.value)}
          onChange={e => handleTitleChange(e)}
          value={title || ''}
        />
        <Divider className={classes.divider} variant="middle" />
        {(!title || title == '' || title == null) && (
          <Typography
            color="#FB9D01"
            fontFamily={'Inter'}
            fontSize="14px"
            fontWeight={500}
          >
            Please enter the “Page Title”
          </Typography>
        )}
      </div>
      <div
        style={{
          flexGrow: 1,
        }}
      />
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        {CardSettingsTypes[entity?.type] &&
          CardSettingsTypes[entity?.type].settings && (
            <>
              <CoreIconButton
                size="small"
                variant="text"
                color="dark"
                onClick={() => settingsClickHandler()}
                id="setting-button"
              >
                {TranslateCardTypes[entity?.type] ? (
                  <Icon icon="material-symbols:translate" />
                ) : (
                  <Icon icon="ion:settings-outline" />
                )}
              </CoreIconButton>
            </>
          )}
        <>
          <CoreIconButton
            size="small"
            variant="text"
            color="secondary"
            onClick={event => {
              event.stopPropagation()
              setOpenPopup(event.currentTarget)
            }}
          >
            <Icon icon={'eva:more-vertical-fill'} />
          </CoreIconButton>
        </>
      </div>

      <SectionPopover
        openPopup={openPopup}
        handleClosePopup={event => {
          if (event) {
            event.stopPropagation()
          }
          handleClosePopup()
        }}
        itemData={[
          {
            text: 'Delete Page',
            action: event => {
              if (event) event.stopPropagation()
              handleDeletePopup()
            },
          },
        ]}
      />
    </div>
  )
}

export default withStyles(styles)(CardTitle)
